import { useState, useEffect, useCallback } from 'react';
import { getMeFavoriteItemsV1 } from '@/services/platform/api/me-—-favorites/me-—-favorites';
import type { FavoriteItemDto } from '@/services/platform/api/model';

export interface UseFavoriteItemsResult {
  data: FavoriteItemDto[];
  isLoading: boolean;
  refetch: () => Promise<void>;
}

export function useFavoriteItems(listGuid: string | undefined): UseFavoriteItemsResult {
  const [data, setData] = useState<FavoriteItemDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(async () => {
    if (!listGuid) {
      setData([]);
      return;
    }
    setIsLoading(true);
    try {
      const response = await getMeFavoriteItemsV1(listGuid);
      if (response.status === 200 && response.data) {
        setData(response.data);
      } else {
        setData([]);
      }
    } catch {
      // silent
    } finally {
      setIsLoading(false);
    }
  }, [listGuid]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, isLoading, refetch };
}
